export const fieldAppliesToCart = (customField, ticketTypes = []) => {
  if (!customField?.ticket_type_targeted) return true;

  const ids = (customField.ticket_type_ids || []).map(Number);
  return ticketTypes.some((tt) => parseInt(tt.quantity || 0, 10) > 0 && ids.includes(Number(tt.id)));
};
